<script setup>
</script>

<template>
  <section class="section">
    <div class="wrap contact-page">
      <h1>Contact</h1>
      <p class="lead">Stuur me een e-mail — dat is de snelste manier om me te bereiken.</p>

      <div class="actions contact-actions">
        <a class="btn btn-primary" href="mailto:serviceburodewilde@gmail.com">Stuur een e-mail</a>
      </div>

      <div class="card contact-panel">
        <div class="contact-row">
          <span class="contact-ico" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 6 9-6" />
            </svg>
          </span>
          <span class="contact-rc">
            <span class="contact-k">E-mail</span>
            <span class="contact-v"><a href="mailto:serviceburodewilde@gmail.com">serviceburodewilde@gmail.com</a></span>
          </span>
        </div>
      </div>

      <p class="contact-meta">
        <span>KvK 66200989</span>
      </p>
    </div>
  </section>
</template>
